export interface AnalisisLaboratorioEspecie {
  id: number;
  laboratorio_id: number;
  especie_id: number;
  tipo_analisis_laboratorio_id: number;
}

export function createEmptyAnalisisLaboratorioEspecie(): AnalisisLaboratorioEspecie {
  return {
    id: null,
    laboratorio_id: null,
    especie_id: null,
    tipo_analisis_laboratorio_id: null
  };
}

export function createAnalisisLaboratorioEspecie(
  params: any
): AnalisisLaboratorioEspecie {
  return {
    ...createEmptyAnalisisLaboratorioEspecie(),
    ...params
  };
}

export interface AuxFormAnalisisLaboratorioEspecie {
  id: number[];
  especie_id: number;
  tipo_analisis_laboratorio_id: number[];
}
